import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import * as filters from './filters'
import 'element-ui/lib/theme-chalk/index.css'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';

Object.keys(filters).forEach(key => {
	Vue.filter(key, filters[key])
})
Vue.config.productionTip = false
// 全局使用 ElementUI
Vue.use(ElementUI)
Vue.use(ViewUI);
// 将 Message 挂载到 Vue 原型上，方便全局调用
Vue.prototype.$message = ElementUI.Message

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
